// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — counter.styled.classic.js, новая — counter.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './counter.styled.classic';
import * as cp from './counter.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Name = isCp ? cp.Name : classic.Name;
export const Zones = isCp ? cp.Zones : classic.Zones;
